export default [
  {name: '택배/등기/소포', value: 'PARCEL_DELIVERY'},
  {name: '직접배송(화물배달)', value: 'DIRECT_DELIVERY'}
];
